var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.validationComplete)?_c('div',[_c('submission-spinner')],1):_vm._e(),(_vm.showEmailSignInForm)?_c('div',[_c('email-login-form',{attrs:{"badLink":true}})],1):_vm._e(),(_vm.showRegistrationForm)?_c('div',{staticClass:"py-16 px-4 overflow-hidden"},[_c('post-login-registration-form')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }